import type { Component } from 'vue';
import { StatusStateMap } from '@/components/common/StatusIcon/statusIcon.ts';
import type { TranslatableLabel } from '@/types';

export type NotificationBoxStatus = Exclude<StatusStateMap, StatusStateMap.Notice>;

export type NotificationBoxProps = {
  /** identificateur unique pour le panneau de statut */
  id?: string;
  /** État du message, détermine l'icône et la couleur à utiliser */
  status: NotificationBoxStatus;
  /** titre optionnel à afficher.
   *
   * Le titre peut être un objet de traduction ou une clé i18n (recommandés), sinon un texte déjà traduit.
   * Dans le cas de cette dernière option, le texte ne sera pas traduit automatiquement lors d'un changement de
   * langue.
   */
  title?: string | TranslatableLabel;
  /**
   * Contenu à afficher dans la boîte de statut. Optionnel car les composantes peuvent
   * normalement passer le contenu dans une slot.
   *
   * Le contenu peut être un objet de traduction ou une clé i18n (recommandés), ou un texte déjà traduit.
   * Dans le cas de cette dernière option, le texte ne sera pas traduit automatiquement lors d'un changement de langue.
   */
  content?: string | TranslatableLabel | Component;
  /** modèle plus petit de boîtes de notification avec l'icône à l'intérieur dans la version mobile */
  compact?: boolean;
  /** modèle qui force un affichage vertical en desktop aussi avec l'icône au haut comme la version mobile normal */
  vertical?: boolean;
  /** Applique le focus sur le contenu au montage de la composante */
  focusOnMount?: boolean;
};

/** Propriétés exposées par les modèles de boîtes de status afin d'assurer le bon fonctionnement dans l'application */
export interface ExposedNotificationBoxProps {
  /** Applique le focus sur le contenu après le montage de la composante */
  focus: () => void;
}

export const DEFAULT_NOTIFICATION_STATUS: NotificationBoxStatus = StatusStateMap.Error;

export const DEFAULT_COMPACT_VALUE: boolean = false;
